import { Trophy } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-muted/30 border-t border-border mt-16">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-gradient-hero flex items-center justify-center">
              <Trophy className="w-5 h-5 text-white" />
            </div>
            <div>
              <div className="font-bold">Volley Puglia</div>
              <div className="text-xs text-muted-foreground">Serie D - Girone A</div>
            </div>
          </div>
          
          <div className="text-sm text-muted-foreground text-center md:text-right">
            <div className="mb-1">Dati ufficiali FIPAV Puglia</div>
          </div>
        </div>
      </div>
    </footer>
  );
};
